const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const getToken = () => localStorage.getItem('admin_token');

const request = async (path, options = {}) => {
  const headers = { ...options.headers };

  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const token = getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin';
    return null;
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Error de red' }));
    throw new Error(err.error || err.detail || `Error ${res.status}`);
  }

  return res.json();
};

const get = (path) => request(path);
const post = (path, body) =>
  body instanceof FormData
    ? request(path, { method: 'POST', body })
    : request(path, { method: 'POST', body: JSON.stringify(body) });
const put = (path, body) =>
  body instanceof FormData
    ? request(path, { method: 'PUT', body })
    : request(path, { method: 'PUT', body: JSON.stringify(body) });
const del = (path) => request(path, { method: 'DELETE' });

// ─── Auth ─────────────────────────
export const loginAdmin = (email, password) =>
  post('/api/auth/login', { email, password });

// ─── Public ───────────────────────
export const getEvents = () => get('/api/events');
export const getEvent = (id) => get(`/api/events/${id}`);
export const getPaymentMethods = (eventId) =>
  get(eventId ? `/api/payment-methods?event_id=${eventId}` : '/api/payment-methods');
export const createReservation = (formData) =>
  post('/api/reservations', formData);
export const getReservationByUuid = (uuid) => get(`/api/reservations/${uuid}`);
export const reservationQrUrl = (uuid) => `${API_BASE}/api/reservations/${uuid}/qr.png`;

// ─── Admin: Events ────────────────
export const adminCreateEvent = (data) => post('/api/admin/events', data);
export const adminUpdateEvent = (id, data) => put(`/api/admin/events/${id}`, data);
export const adminDeleteEvent = (id) => del(`/api/admin/events/${id}`);
export const adminCloneEvent = (id) => post(`/api/admin/events/${id}/clone`, {});
export const adminPublishEvent = (id) => post(`/api/admin/events/${id}/publish`, {});
export const adminUnpublishEvent = (id) => post(`/api/admin/events/${id}/unpublish`, {});
export const adminListEvents = () => get('/api/admin/events/list');

// ─── Admin: Layout ────────────────
export const adminGetLayout = (eventId) => get(`/api/admin/events/${eventId}/layout`);
export const adminSaveLayout = (eventId, data) => put(`/api/admin/events/${eventId}/layout`, data);

// ─── Admin: Reservations ──────────
export const adminGetReservations = (eventId) => get(`/api/admin/events/${eventId}/reservations`);
export const adminGetPendingReservations = () => get('/api/admin/reservations/pending');
export const adminReservationAction = (resId, action, note) =>
  post(`/api/admin/reservations/${resId}/action`, { action, note });
export const adminMarkAttended = (resId) =>
  post(`/api/admin/reservations/${resId}/attend`, {});

// ─── Admin: QR ────────────────────
export const adminScanQr = (uuid) => post('/api/admin/scan-qr', { uuid });

// ─── Admin: Payment Methods ───────
export const adminGetPaymentMethods = () => get('/api/admin/payment-methods');
export const adminCreatePaymentMethod = (data) => post('/api/admin/payment-methods', data);
export const adminUpdatePaymentMethod = (id, data) => put(`/api/admin/payment-methods/${id}`, data);
export const adminDeletePaymentMethod = (id) => del(`/api/admin/payment-methods/${id}`);
